import React, { useState } from 'react';
import styled from '@emotion/styled';
import { DTOProfileImageInfo } from 'src/apis/dto/DTOProfileImageInfo';
import IcVolume40Fill from 'src/assets/images/icVolume40Fill.svg';
import IcVolumeOffFill from 'src/assets/images/icVolumeOffFill.svg';
import OptimizeImage from 'src/components/OptimizeImage';
import useIntersectionAutoplay from 'src/hooks/useIntersectionAutoplay';
import { hexToRgb } from 'src/utils/common';
const Image = styled(OptimizeImage)`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;
const Video = styled.video`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;
const ProfileImageContainer = styled.div<{
  isFirst: boolean;
}>`
  width: 100%;
  ${({
  isFirst
}) => isFirst ? `
    aspect-ratio: 343 / 563;
    height: 100%;
  ` : `
    aspect-ratio: 1 / 1;
  `}
  position: relative;
`;
const MuteButton = styled.button`
  all: unset;
  cursor: pointer;
  color: ${({
  theme
}) => theme.color.contentBrightFixed};
  display: flex;
  width: 26px;
  height: 26px;
  justify-content: center;
  align-items: center;
  background-color: ${({
  theme
}) => `rgba(${hexToRgb(theme.color.surfaceBrightFixed)}, .3)`};
  flex: 0 0 auto;
  border-radius: 26px;
  position: absolute;
  bottom: 45px;
  right: 16px;
  z-index: 1;
`;
const MuteIcon = styled(IcVolumeOffFill)`
  width: 16px;
  height: 16px;
`;
const VolumeIcon = styled(IcVolume40Fill)`
  width: 16px;
  height: 16px;
`;
const ProfileImage = ({
  isFirst = false,
  profileImageInfo,
  children
}: {
  isFirst?: boolean;
  profileImageInfo?: DTOProfileImageInfo;
  children?: React.ReactNode;
}) => {
  const [isMuted, setIsMuted] = useState(true);
  const toggleVideoMute = () => setIsMuted(prev => !prev);
  const isVideoProfile = profileImageInfo?.profileVideoUrl;
  const autoplayRef = useIntersectionAutoplay();
  return <ProfileImageContainer isFirst={isFirst} data-sentry-element="ProfileImageContainer" data-sentry-component="ProfileImage" data-sentry-source-file="Image.tsx">
      {isVideoProfile ? <>
          {/* eslint-disable-next-line styled-components-a11y/media-has-caption */}
          <Video controls={false} muted={isMuted} playsInline loop ref={autoplayRef}>
            <source src={profileImageInfo?.profileVideoUrl} type='video/mp4' />
          </Video>
        </> : <Image src={profileImageInfo?.profileImageUrl || '/images/profile/imgProfileSource.jpg'} alt='user profile' fill />}
      {isVideoProfile && <MuteButton onClick={toggleVideoMute}>{isMuted ? <MuteIcon /> : <VolumeIcon />}</MuteButton>}
      {children}
    </ProfileImageContainer>;
};
export default ProfileImage;